import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonSearchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person_search"}/>
}
